import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormColor from "./FormColor";

function FormColorTC(props) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormColor name={props.name} options={props.options} />
    </FormFieldTwoColumns>
  );
}

FormColorTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  nullable: PropTypes.bool,
  disableAlpha: PropTypes.bool,
};

FormColorTC.defaultProps = {
  disableAlpha: false,
};

export default FormColorTC;
